import BaseRepository from './BaseRepository';

export default class RequestQuotesRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/request-quotes';
    }

    deleteRequestQuote(requestQuoteId)
    {
        return this.request('DELETE', `${this.getEndpoint()}/${requestQuoteId}`);
    }

    updateRequestQuote(requestQuoteId, data)
    {
        return this.request('PATCH', `${this.getEndpoint()}/${requestQuoteId}`, data);
    }

    addInformativeService(requestQuoteId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${requestQuoteId}/add-informative-service`, data);
    }

    updateInformativeService(requestQuoteId, requestServiceId, data)
    {
        return this.request('PATCH', `${this.getEndpoint()}/${requestQuoteId}/update-informative-service/${requestServiceId}`, data);
    }

    addInformativeHotel(requestQuoteId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${requestQuoteId}/add-informative-hotel`, data);
    }

    updateInformativeHotel(requestQuoteId, requestServiceId, data)
    {
        return this.request('PATCH', `${this.getEndpoint()}/${requestQuoteId}/update-informative-hotel/${requestServiceId}`, data);
    }

    addInformativeFlight(requestQuoteId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${requestQuoteId}/add-informative-flight`, data);
    }

    updateInformativeFlight(requestQuoteId, requestServiceId, data)
    {
        return this.request('PATCH', `${this.getEndpoint()}/${requestQuoteId}/update-informative-flight/${requestServiceId}`, data);
    }
}
